import { globalGetService } from '@/utils/globalApiServices';
import { Pagination } from '@/utils/types';
import {
  AuthenticatedUserSuggestion,
  AuthenticatedUserSuggestionParams,
  EventHistory,
} from './types';
import { getTimezone } from '@/utils/time';

export const getEventHistory = async (params?: Record<string, unknown>) => {
  const response = await globalGetService('mno/event', {
    ...params,
    timezone: getTimezone(),
  });
  return response?.ok ? (response.data as Pagination<EventHistory>) : undefined;
};

export const getAuthenticatedUserSuggestions = async (
  params: AuthenticatedUserSuggestionParams
) => {
  const response = await globalGetService(
    'mno/event/suggestion/authenticatedUser',
    params
  );
  return (response?.ok ? response.data : []) as AuthenticatedUserSuggestion[];
};

export const downloadEventHistoryAsCsv = async (
  query = {}
): Promise<ArrayBuffer | undefined> => {
  const response = await globalGetService(
    'mno/event/csv',
    { ...query, timezone: getTimezone() },
    { responseType: 'arraybuffer' }
  );
  if (response?.ok) {
    return response.data;
  }
  return undefined;
};
